export interface OrderCancellationReasonOption {
  readonly value: string;
  readonly label: string;
}

export const OrderCancellationReasons: ReadonlyArray<OrderCancellationReasonOption> = [
  { value: 'out_of_stock', label: 'Няма наличност' },
  { value: 'cancelled_by_customer', label: 'Отменена от клиента' },
  { value: 'customer_unreachable', label: 'Няма контакт с клиента' },
  { value: 'long_delivery_time', label: 'Дълъг срок за доставка' },
  { value: 'high_delivery_cost', label: 'Прекалено висока стойност за доставка' },
  { value: 'long_restock_time', label: 'Дълъг срок на доставка преди продуктът да бъде отново наличен' },
  { value: 'better_offer_elsewhere', label: 'По-добра оферта в друг магазин' },
  { value: 'courier_delivery_failure', label: 'Недоставена пратка по вина на куриера' },
  { value: 'customer_changed_mind', label: 'Клиентът промени решението си' },
  { value: 'invoice_without_vat', label: 'Фактура без ДДС' },
  { value: 'other', label: 'Друг' }
];

export const OtherOrderCancellationReason = 'other';
